import React, { useState, useEffect, useRef } from "react";
import V1 from "../../Video/V1.mp4";
import V2 from "../../Video/V2.mp4";
import V3 from "../../Video/V3.mp4";
import V4 from "../../Video/V4.mp4";
import Pic from "../Photo/Pic";
import WeedingPic from "../Photo/WeedingPic";

const videoSources = [V1, V2, V3, V4];

function Home() {
  const [currentVideo, setCurrentVideo] = useState(0);
  const [fade, setFade] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play(); // Ensure video starts playing
    }
  }, [currentVideo]);

  const handleVideoEnd = () => {
    setFade(true); // Start fade-out effect
    setTimeout(() => {
      setCurrentVideo((prevIndex) => (prevIndex + 1) % videoSources.length);
      setFade(false); // Remove fade effect after video change
    },500); // Delay for smooth transition
  };

  return (
    <div className="home-container">
      <div className={`video-container ${fade ? "fade-out" : "fade-in"}`}>
        <video
          key={currentVideo}
          ref={videoRef}
          src={videoSources[currentVideo]}
          autoPlay
          muted
          onEnded={handleVideoEnd}
          className="video-player"
        />
      </div>
      <Pic/>
      <WeedingPic/>
    </div>
  );
}

export default Home;
